import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '@/src/store'

interface ErrorState {
    isError: boolean
    errorDetails: {
        code: string
        message: string
    }
}

const initialState: ErrorState = {
    isError: false,
    errorDetails: {
        code: '',
        message: ''
    }
}

const errorHandlingSlice = createSlice({
    name: 'errorHandling',
    initialState,
    reducers: {
        setError: (
            state,
            action: PayloadAction<{ code: string; message: string }>
        ) => {
            state.isError = true
            state.errorDetails = action.payload
        },
        clearError: (state) => {
            state.isError = false
            state.errorDetails = { code: '', message: '' }
        }
    }
})

export const { setError, clearError } = errorHandlingSlice.actions
export const getErrorState = (state: RootState) => state.errorHandling

export default errorHandlingSlice.reducer
